import { BorderedContainer } from 'core/components/common/BorderedContainer';
import { IncidentDetailPatient } from '../useIncidentDetailForHiroshima';
import { SectionTitle } from 'core/components/common/SectionTitle';
import { InfoDisplay } from 'core/components/JianDetail/common/InfoDisplay';
import { convertToPresenceAbsence } from 'core/components/common/converters';
import { formatDateTime } from 'core/utils/date';
import { FC } from 'react';

type Props = {
  specialTreatment: IncidentDetailPatient['treatments'][number]['data'];
};

export const SpecialTreatmentView: FC<Props> = ({ specialTreatment }) => (
  <BorderedContainer>
    <div className="flex flex-col gap-[24px]">
      <SectionTitle text="特定行為等" />
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="CPA情報"
          content={specialTreatment.cpaData.cpaTiming}
        />
        <InfoDisplay
          title="CPA情報 自由入力欄"
          content={specialTreatment.cpaData.cpaNote}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="除細動"
          content={convertToPresenceAbsence(specialTreatment.defibrillation)}
        />
        <InfoDisplay
          title="除細動の回数"
          content={
            specialTreatment.defibrillationCount
              ? `${specialTreatment.defibrillationCount} 回`
              : ''
          }
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="気道確保"
          content={convertToPresenceAbsence(
            specialTreatment.airwayEstablishment
          )}
        />
        <InfoDisplay title="器具" content={specialTreatment.intubationDevice} />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="静脈路確保"
          content={convertToPresenceAbsence(
            specialTreatment.ivAccessEstablishment
          )}
        />
        <InfoDisplay
          title="静脈路確保"
          content={specialTreatment.ivAccessTiming}
        />
        <InfoDisplay
          title="薬剤投与"
          content={convertToPresenceAbsence(
            specialTreatment.medicationAdministration
          )}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="血糖測定"
          content={convertToPresenceAbsence(specialTreatment.glu)}
        />
        <InfoDisplay
          title="血糖値"
          content={
            specialTreatment.gluValue
              ? `${specialTreatment.gluValue} mg/dl`
              : ''
          }
        />
        <InfoDisplay
          title="ブドウ糖投与"
          content={convertToPresenceAbsence(
            specialTreatment.glucoseAdministration
          )}
        />
      </div>
      <div className="flex flex-wrap gap-x-[40px] gap-y-[24px] xl:gap-x-[96px]">
        <InfoDisplay
          title="指示医師名"
          content={specialTreatment.instructingDoctorName}
        />
        <InfoDisplay
          title="指示時刻"
          content={
            specialTreatment.doctorInstructionReceivedAt
              ? formatDateTime(
                  specialTreatment.doctorInstructionReceivedAt,
                  'MM/dd HH:mm'
                )
              : ''
          }
        />
      </div>
    </div>
  </BorderedContainer>
);
